import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'raffleName',
      type: 'input',
      label: '活动名称',
      clearable: true,
      placeholder: '请输入活动名称'
    },
    {
      field: 'raffleStatus',
      type: 'select',
      label: '活动状态',
      clearable: true,
      filterable: true,
      placeholder: '请选择活动状态',
      options: [
        {title: '已激活', value: '1'},
        {title: '未激活', value: '0'},
      ]
    }
  ]
}
